export enum ValueType{

    /**
     *值类型
     */
    Value = 0,

    /**
     * 表达式
     */
    Express = 1
}